import { IProfile } from 'shared-state/identity/types';
import Swal from 'sweetalert2';
import './style.css';
import userRedirection from 'media/img/user-redirection.svg';
import IvicosStrings from 'kits/language/stringKit';

// Constants
const SWAL_CUSTOM_CLASSES = {
    popup: 'my-swal-popup',
    htmlContainer: 'my-swal-content',
    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button',
    actions: 'my-swal-actions'
} as const;

const CONFIRMATION_SWAL_CLASSES = {
    popup: 'my-confirm-swal-popup',
    htmlContainer: 'my-swal-content',
    confirmButton: 'my-close-button'
} as const;

export const showConfirmationDialog = (isRedirected: boolean, name?: string): void => {
    const icon = isRedirected ? 'success' : 'error';
    const text =
        isRedirected && name ? IvicosStrings.redirectUserModal.confirmationText.replace('{username}', name) : IvicosStrings.redirectUserModal.errorText;

    Swal.fire({
        text,
        icon,
        confirmButtonText: IvicosStrings.redirectUserModal.closeButton,
        customClass: CONFIRMATION_SWAL_CLASSES
    });
};

const handleKeyDown = (event: KeyboardEvent): void => {
    if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
    }
};

// Main function
export const redirectUserModal = async (user: IProfile, redirectUserToPersonalRoom: (userId: string, roomId: string) => void): Promise<void> => {
    const title = IvicosStrings.redirectUserModal.title.replace('{username}', user.displayName);

    try {
        const result = await Swal.fire({
            html: `
                <div style="text-align: start;">
                 <img src=${userRedirection} width="100%" height="50" style="text-align: center;" />
                 <h3>${title}</h3>
                 <p>${IvicosStrings.redirectUserModal.text1}</p>
                 <p>${IvicosStrings.redirectUserModal.text2}</p>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: IvicosStrings.redirectUserModal.yes,
            cancelButtonText: IvicosStrings.redirectUserModal.no,
            reverseButtons: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: SWAL_CUSTOM_CLASSES,
            didOpen: () => document.addEventListener('keydown', handleKeyDown, true),
            willClose: () => document.removeEventListener('keydown', handleKeyDown, true)
        });

        if (result.isConfirmed) {
            if (!user.uid || !user.room) {
                showConfirmationDialog(false);
                return;
            }
            redirectUserToPersonalRoom(user.uid, user.room);
        }
    } catch (error) {
        showConfirmationDialog(false);
    }
};

export const redirectionInformationModal = (name: string): void => {
    const title = IvicosStrings.redirectUserModal.informationModal.title.replace('{username}', name);
    const text = IvicosStrings.redirectUserModal.informationModal.text.replace('{username}', name);
    Swal.fire({
        title,
        text,
        icon: 'info',
        confirmButtonText: IvicosStrings.redirectUserModal.closeButton,
        customClass: { ...CONFIRMATION_SWAL_CLASSES, title: 'my-swal-information-title' }
    });
};
